export * from './strategy.component';
